import React from 'react';
import { Link } from 'react-router-dom';
import VideoModal from '../ModalVideo/VideoModal';
import blogs from '../../api/blogs';

const NewsList = props => {
	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	return (
		<section className='py-[120px] md:py-[90px] sm:py-[80px]'>
			<div className='wraper'>
				<div className='grid-cols-2 grid gap-10'>
					{blogs.map((blog, bitem) => (
						<div className='post mb-[70px] format-standard-image' key={bitem}>
							<div className='entry-media video-holder'>
								<img className='w-full' src={blog.newsCoverImg} alt='' />
								<VideoModal />
							</div>
							<h3 className='text-[30px] md:text-[25px] sm:text-[22px] text-[#282e3f] font-normal font-heading-font leading-[40px] pt-7 transition-all mb-[20px] group'>
								<Link
									className='group-hover:text-[#c0b596] transition-all'
									onClick={ClickHandler}
									to={`/news/${blog.slug}`}
								>
									{blog.title}
								</Link>
							</h3>
							<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>{blog.description}</p>
							<Link
								onClick={ClickHandler}
								to={`/news/${blog.slug}`}
								className='text-[#666] uppercase underline font-base-font text-[15px] font-semibold transition-all hover:text-[#c0b596]'
							>
								LIRE PLUs...
							</Link>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default NewsList;
